import React from 'react';
import { inject } from 'mobx-react';
import { MarketplaceOrderEditShippingStepTemplate } from 'themes/modules/order/pages/wizard';

@inject(i => ({
	marketplaceOrderEditViewStore: i.rootStore.marketplaceOrderEditViewStore,
}))
class MarketplaceOrderEditShippingStep extends React.Component {
	render() {
		return <MarketplaceOrderEditShippingStepTemplate {...this.props} />;
	}
}

export default MarketplaceOrderEditShippingStep;



// WEBPACK FOOTER //
// ./src/modules/order/pages/wizard/MarketplaceOrderEditShippingStep.jsx